// class BrandSwitcher extends HTMLElement {
//   connectedCallback() {
//     this.current = this.getAttribute('current-brand');
//     this.color = this.getAttribute('selected-color');
//     this.addEventListener('click', (e) => this.handleClick(e));
//   }

//   async handleClick(e) {
//     const btn = e.target.closest('.brand-btn');
//     if (!btn) return;

//     const brand = btn.dataset.brand;
//     const color = btn.dataset.color || this.color;
//     if (brand === this.current) return;

//     try {
//       const res = await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify({ attributes: { brand, brand_color: color } })
//       });
//       if (!res.ok) throw new Error('Update failed');

//       this.dispatchEvent(new CustomEvent("brand:changed", {
//         bubbles: true,
//         detail: { brand, color }
//       }));

//       location.reload();
//     } catch (err) {
//       console.error('[BrandSwitcher] Error:', err);
//     }
//   }
// }
// customElements.define('brand-switcher', BrandSwitcher);



class BrandSwitcher extends HTMLElement {
  connectedCallback() {
    this.current = this.getAttribute('current-brand');
    this.color = this.getAttribute('selected-color');
    this.addEventListener('click', (e) => this.handleClick(e));
  }

  async handleClick(e) {
    e.preventDefault();
    const btn = e.target.closest('.brand-btn');
    if (!btn) return;

    const brand = btn.dataset.brand;
    const color = btn.dataset.color || this.color;
    if (brand === this.current) return;

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { brand, brand_color: color } })
      });
      if (!res.ok) throw new Error('Update failed');

      this.dispatchEvent(new CustomEvent("brand:changed", {
        bubbles: true,
        detail: { brand, color }
      }));

      const path = window.location.pathname;
      const currentUrl = new URL(window.location.href);

      if (path.includes('/products/') || path.includes('/collections/')) {
        const homeUrl = `/?brand=${encodeURIComponent(brand)}`;
        window.location.href = homeUrl;
      } else {
        if (!currentUrl.searchParams.has('brand')) {
          currentUrl.searchParams.set('brand', brand);
          window.location.href = currentUrl.toString(); 
        } else {
          currentUrl.searchParams.set('brand', brand);
          window.location.href = currentUrl.toString();
        }
      }
    } catch (err) {
      console.error('[BrandSwitcher] Error:', err);
    }
  }
}

customElements.define('brand-switcher', BrandSwitcher);
